import { MemberLevelInfo } from "../interface/member-level-info";

export class MemberLevelModel {
    constructor (){
        this.toggle = false;
    }
    toggle: boolean;
    memberLeveldata: MemberLevelInfo[];
    dataAvailable:boolean;
    memberDetail: {
        firstName: String;
        lastName: String;
        fboId: String;
        memberLevel: String;
        operatingCountry: String;
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/member-level-model.ts